import { useState, useEffect } from 'react';
import AirQualityService, { AirQualityData } from '../services/airQualityService';

export const useAirQuality = (lat?: number, lon?: number) => {
  const [data, setData] = useState<AirQualityData | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const result = await AirQualityService.getAirQuality(lat, lon);
        setData(result);
        setError(null);
      } catch (err) {
        setError('Failed to fetch air quality');
      } finally {
        setLoading(false);
      }
    };

    fetchData();
    const interval = setInterval(fetchData, 30 * 60 * 1000); // Every 30 minutes
    return () => clearInterval(interval);
  }, [lat, lon]);

  const getAqiLabel = (aqi: number): string => {
    const labels = ['Good', 'Fair', 'Moderate', 'Poor', 'Very Poor'];
    return labels[aqi - 1] || 'Unknown';
  };

  const getAqiColor = (aqi: number): string => {
    const colors = ['#00ff00', '#ffff00', '#ff9900', '#ff0000', '#990000'];
    return colors[aqi - 1] || '#ffffff';
  };

  return { data, loading, error, getAqiLabel, getAqiColor };
};